import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import StreamPlan from "./components/StreamPlan";
import Footer from "./components/Footer";
import Datenschutz from "./components/Datenschutz";

function App() {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<StreamPlan />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
